export default "__VITE_ASSET__BQ7LiGEw__"